/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoard } from 'app/shared/model/tumor-board.model';
import { MemberRole } from 'app/shared/model/enumerations/member-role.model';

export interface ITumorBoardMember {
  id?: string;
  joinedAt?: number;
  left?: boolean | null;
  leftAt?: number | null;
  memberId?: string | null;
  memberRole?: keyof typeof MemberRole | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  tumorBoard?: ITumorBoard | null;
}

export const defaultValue: Readonly<ITumorBoardMember> = {
  left: false,
  active: false,
};
